import { useQuery } from '@tanstack/react-query';
import { meldingGebeurtenissenService } from '../services/meldingGebeurtenissenService';

/**
 * Tijdlijn van één melding. Sleutel onder de bestaande prefix
 * ['software_meldingen', …]: elke mutatie die de meldingen ververst (pijplijn,
 * feedback, vraag terug, meldknop) ververst daarmee ook de tijdlijn, zonder
 * dat die hooks deze hook hoeven te kennen.
 */
export function useMeldingGebeurtenissen(meldingId: string | null | undefined, enabled = true) {
  return useQuery({
    queryKey: ['software_meldingen', 'gebeurtenissen', meldingId],
    queryFn: () => meldingGebeurtenissenService.voorMelding(meldingId!),
    enabled: enabled && !!meldingId,
    staleTime: 15 * 1000,
  });
}

/** Tijdlijn van één bouwpunt; prefix ['tom_build_reviews'] zoals de bouwlijst-hook. */
export function useBouwpuntGebeurtenissen(bouwpuntId: string | null | undefined, enabled = true) {
  return useQuery({
    queryKey: ['tom_build_reviews', 'gebeurtenissen', bouwpuntId],
    queryFn: () => meldingGebeurtenissenService.voorBouwpunt(bouwpuntId!),
    enabled: enabled && !!bouwpuntId,
    staleTime: 15 * 1000,
  });
}
